<h2 mat-dialog-title>{{ 'login.reset' | translate }}</h2>
<mat-dialog-content>
    <div>
        <p style="display: {{'en' | translate}};">
            Please enter your email address. We will send you an email with instructions on how to change your password.
        </p>
        <p style="display: {{'es' | translate}};">
            Por favor, introduzca su dirección de correo electrónico. Le enviaremos un correo electrónico con
            instrucciones sobre cómo cambiar su contraseña.
        </p>
        <p style="display: {{'cat' | translate}};">
            Si us plau, ingressi el seu correu electrònic. Us enviarem un correu electrònic amb instruccions sobre com
            canviar la vostra contrasenya.
        </p>

    </div>
    <form [formGroup]="resetPasswordEmailForm">
        <div>
            <mat-form-field style="width: 80%;">
                <mat-label>{{ 'login.email_address' | translate }}</mat-label>
                <input matInput type="email" name="email" formControlName="email">
                <mat-icon matSuffix>email</mat-icon>
            </mat-form-field>
        </div>
    </form>
</mat-dialog-content>
<mat-dialog-actions>
    <button mat-flat-button mat-dialog-close>
        <span>{{'buttons.cancel' | translate}}</span>
    </button>
    <button mat-flat-button (click)="sendResetPasswordEmail(resetPasswordEmailForm)"
        style="color: white; background-color: #5fbeb5;">
        <span>{{ 'buttons.send' | translate}}</span>
    </button>
    <mat-progress-bar *ngIf="showBar" mode="indeterminate"></mat-progress-bar>
</mat-dialog-actions>